const apiVersion = process.env.VUE_APP_API_VERSION.replace(/\./g, '_')
const baseUrl = process.env.VUE_APP_API_BASEURL + apiVersion + '/'
// 通知下单默认字段
export const thenoticeTableData = [{
    depart: '国内B2C',
    checked: false,
    depart_code: 'b2c',
    user_id: ''
  },
  {
    depart: '亚马逊',
    checked: false,
    depart_code: "amazon",
    user_id: ''
  },
  {
    depart: '长沙全球商城',
    checked: false,
    depart_code: "cs_global_mall",
    user_id: ''
  },
  {
    depart: '深圳全球商城',
    checked: false,
    depart_code: "sz_global_mall",
    user_id: ''
  },
  {
    depart: '国内渠道',
    checked: false,
    depart_code: "nation_channels",
    user_id: ''
  },
  {
    depart: '海外渠道',
    checked: false,
    depart_code: "overseas_channels",
    user_id: ''
  },
  {
    depart: '市场部',
    checked: false,
    depart_code: "market_depart",
    user_id: ''
  },
  {
    depart: 'F2B211/1688',
    checked: false,
    depart_code: "f2b211_1688",
    user_id: ''
  }
]
// 下单明细表格配置字段
export const spsdmqKeylist = {
  baseKeys: [{
    name: '品牌',
    key: 'brand',
    value: false
  }, {
    name: '产品名称',
    key: 'name',
    value: false
  }, {
    name: '产品图片',
    key: 'image',
    value: false
  }, {
    name: '产品SPU',
    key: 'spu',
    value: false
  }, {
    name: '产品SKU',
    key: 'sku',
    value: false
  }, {
    name: '出厂价（TCO成本）',
    key: 'mould_cost',
    value: false
  }, {
    name: '规格参数',
    key: 'params',
    value: false
  }],
  natureKeys: [{
    name: '产品材质',
    key: 'material',
    value: false
  }, {
    name: '协议',
    key: 'protocol',
    value: false
  }, {
    name: '速率',
    key: 'rate',
    value: false
  }, {
    name: '包装',
    key: 'package',
    value: false
  }, {
    name: '安规',
    key: 'safe',
    value: false
  }, {
    name: '接口(输入)',
    key: 'interface',
    value: false
  }, {
    name: '尺码/数量/长度',
    key: 'other',
    value: false
  }, {
    name: '产品颜色',
    key: 'color',
    value: false
  }, {
    name: '功能/版本',
    key: 'version',
    value: false
  }, {
    name: '输出接口',
    key: 'output',
    value: false
  }, {
    name: '69码',
    key: 'code69',
    value: false
  }, {
    name: '备料数量',
    key: 'material_num',
    value: false
  }, {
    name: '模具费(塑胶)',
    key: 'mould_fare_sj',
    value: false
  }, {
    name: '模具费(五金)',
    key: 'mould_fare_wj',
    value: false
  }, {
    name: '电子',
    key: 'electron_fare',
    value: false
  }, {
    name: '结构/本体',
    key: 'structure_fare',
    value: false
  }, {
    name: '电源',
    key: 'power_fare',
    value: false
  }, {
    name: '线材',
    key: 'line_fare',
    value: false
  }, {
    name: '包材',
    key: 'package_fare',
    value: false
  }, {
    name: '辅料/配件',
    key: 'parts_fare',
    value: false
  }, {
    name: '硬盘/运费/其他/DDR',
    key: 'other_fare',
    value: false
  }, {
    name: '加工费用',
    key: 'process_fare',
    value: false
  }, {
    name: '认证/测试费用',
    key: 'auth_test_fare',
    value: false
  }, {
    name: '总成本(未摊模具)',
    key: 'total_cost',
    value: false
  }, {
    name: '物料成本价',
    key: 'tco_cost',
    value: false
  }, {
    name: 'TCO毛利率',
    key: 'tco_rate',
    value: false
  }, {
    name: '代理商价',
    key: 'agent_price',
    value: false
  }, {
    name: '渠道毛利润率',
    key: 'channel_rate',
    value: false
  }, {
    name: '经销价',
    key: 'distribution_price',
    value: false
  }, {
    name: '经销商毛利率',
    key: 'distribution_rate',
    value: false
  }, {
    name: '建议零售价',
    key: 'retail_price',
    value: false
  }, {
    name: '最低零售价',
    key: 'min_retail_price',
    value: false
  }, {
    name: 'B2C毛利润率',
    key: 'b2c_rate',
    value: false
  }, {
    name: '国内B2C',
    key: 'b2c',
    value: false
  }, {
    name: '亚马逊',
    key: 'amazon',
    value: false
  }, {
    name: '长沙全球商城',
    key: 'cs_global_mall',
    value: false
  }, {
    name: '深圳全球商城',
    key: 'sz_global_mall',
    value: false
  }, {
    name: '国内渠道',
    key: 'nation_channels',
    value: false
  }, {
    name: '海外渠道',
    key: 'overseas_channels',
    value: false
  }, {
    name: '市场部',
    key: 'market_depart',
    value: false
  }, {
    name: 'F2B211/1688',
    key: 'f2b211_1688',
    value: false
  }, {
    name: '总计',
    key: 'zj',
    value: false
  }, {
    name: '备注',
    key: 'remark',
    value: false
  }]
}
export const spsdmqKeylistMr = {
  baseKeys: [{
    name: '品牌',
    key: 'brand',
    value: false
  }, {
    name: '产品名称',
    key: 'name',
    value: false
  }, {
    name: '产品图片',
    key: 'image',
    value: false
  }, {
    name: '产品SPU',
    key: 'spu',
    value: false
  }, {
    name: '产品SKU',
    key: 'sku',
    value: false
  }, {
    name: '出厂价（TCO成本）',
    key: 'mould_cost',
    value: false
  }, {
    name: '规格参数',
    key: 'params',
    value: false
  }],
  natureKeys: [{
    name: '产品材质',
    key: 'material',
    value: false
  }, {
    name: '协议',
    key: 'protocol',
    value: false
  }, {
    name: '速率',
    key: 'rate',
    value: false
  }, {
    name: '包装',
    key: 'package',
    value: false
  }, {
    name: '安规',
    key: 'safe',
    value: false
  }, {
    name: '接口(输入)',
    key: 'interface',
    value: false
  }, {
    name: '尺码/数量/长度',
    key: 'other',
    value: false
  }, {
    name: '产品颜色',
    key: 'color',
    value: false
  }, {
    name: '功能/版本',
    key: 'version',
    value: false
  }, {
    name: '输出接口',
    key: 'output',
    value: false
  }, {
    name: '69码',
    key: 'code69',
    value: false
  }, {
    name: '备料数量',
    key: 'material_num',
    value: false
  }, {
    name: '模具费(塑胶)',
    key: 'mould_fare_sj',
    value: false
  }, {
    name: '模具费(五金)',
    key: 'mould_fare_wj',
    value: false
  }, {
    name: '电子',
    key: 'electron_fare',
    value: false
  }, {
    name: '结构/本体',
    key: 'structure_fare',
    value: false
  }, {
    name: '电源',
    key: 'power_fare',
    value: false
  }, {
    name: '线材',
    key: 'line_fare',
    value: false
  }, {
    name: '包材',
    key: 'package_fare',
    value: false
  }, {
    name: '辅料/配件',
    key: 'parts_fare',
    value: false
  }, {
    name: '硬盘/运费/其他/DDR',
    key: 'other_fare',
    value: false
  }, {
    name: '加工费用',
    key: 'process_fare',
    value: false
  }, {
    name: '认证/测试费用',
    key: 'auth_test_fare',
    value: false
  }, {
    name: '总成本(未摊模具)',
    key: 'total_cost',
    value: false
  }, {
    name: '物料成本价',
    key: 'tco_cost',
    value: false
  }, {
    name: 'TCO毛利率',
    key: 'tco_rate',
    value: false
  }, {
    name: '代理商价',
    key: 'agent_price',
    value: false
  }, {
    name: '渠道毛利润率',
    key: 'channel_rate',
    value: false
  }, {
    name: '经销价',
    key: 'distribution_price',
    value: false
  }, {
    name: '经销商毛利率',
    key: 'distribution_rate',
    value: false
  }, {
    name: '建议零售价',
    key: 'retail_price',
    value: false
  }, {
    name: '最低零售价',
    key: 'min_retail_price',
    value: false
  }, {
    name: 'B2C毛利润率',
    key: 'b2c_rate',
    value: false
  }]
}
export const zdlist = [{
  key: 'indxs',
  value: true
}, {
  key: 'seq',
  value: true
}, {
  key: 'brand',
  value: true
}, {
  key: 'name',
  value: true
}, {
  key: 'image',
  value: true
}, {
  key: 'spu',
  value: true
}, {
  key: 'sku',
  value: true
}, {
  key: 'params',
  value: true
}, {
  key: 'jgbom',
  value: true
}, {
  key: 'bzbom',
  value: true
}, {
  key: 'material',
  value: true
}, {
  key: 'protocol',
  value: true
}, {
  key: 'rate',
  value: true
}, {
  key: 'package',
  value: true
}, {
  key: 'safe',
  value: true
}, {
  key: 'interface',
  value: true
}, {
  key: 'other',
  value: true
}, {
  key: 'color',
  value: true
}, {
  key: 'version',
  value: true
}, {
  key: 'output',
  value: true
}, {
  key: 'code69',
  value: true
}, {
  key: 'material_num',
  value: true
}, {
  key: 'order_num',
  value: true
}, {
  key: 'mould_fare_sj',
  value: true
}, {
  key: 'mould_fare_wj',
  value: true
}, {
  key: 'electron_fare',
  value: true
}, {
  key: 'structure_fare',
  value: true
}, {
  key: 'power_fare',
  value: true
}, {
  key: 'line_fare',
  value: true
}, {
  key: 'package_fare',
  value: true
}, {
  key: 'parts_fare',
  value: true
}, {
  key: 'other_fare',
  value: true
}, {
  key: 'process_fare',
  value: true
}, {
  key: 'auth_test_fare',
  value: true
}, {
  key: 'total_cost',
  value: true
}, {
  key: 'mould_cost',
  value: true
}, {
  key: 'tco_cost',
  value: true
}, {
  key: "tco_rate",
  value: true
}, {
  key: "agent_price",
  value: true
}, {
  key: 'channel_rate',
  value: true
}, {
  key: 'distribution_price',
  value: true
}, {
  key: 'distribution_rate',
  value: true
}, {
  key: 'retail_price',
  value: true
}, {
  key: 'min_retail_price',
  value: true
}, {
  key: 'b2c_rate',
  value: true
}]
export const addBomitem = {
  id: 0,
  bom_code: '',
  bom_name: '',
  bom_desc: '',
  molecule: '',
  denominator: '',
  total_price: '',
  price: '',
  remark: ''
}
export const addbzljitem = {
  id: 0,
  name: '',
  bom_code: '',
  bom_name: '',
  spec: '',
  molecule: 1,
  denominator: 1,
  price: '',
  total_price: '',
  remark: ''
}
export const addggdyitem = {
  id: 0,
  project_id: null,
  name: "",
  image: "",
  spu: "",
  sku: "",
  color: "",
  material: "",
  size: "",
  output: "",
  input: "",
  line: "",
  other: "",
  protocol: "",
  rate: "",
  package: "",
  safe: "",
  Interface: "",
  version: "",
  material_num: "",
  order_num: "",
  mould_fare_sj: "",
  mould_fare_wj: "",
  electron_fare: "",
  structure_fare: "",
  line_fare: "",
  package_fare: "",
  parts_fare: "",
  process_fare: "",
  auth_test_fare: "",
  total_cost: "",
  mould_cost: "",
  tco_cost: "",
  tco_rate: "",
  agent_price: "",
  channel_rate: "",
  distribution_price: "",
  retail_price: "",
  min_retail_price: "",
  b2c_rate: "",
  _isNew: true
}
export const ggdykeytable = [{
    name: '勾选',
    field: 'indxs'
  }, {
    name: '序号',
    field: 'seq'
  }, {
    name: '品牌',
    field: 'brand'
  },
  {
    name: '产品名称',
    field: 'name'
  }, {
    name: '产品图片',
    field: 'image'
  }, {
    name: '产品SPU',
    field: 'spu'
  }, {
    name: '产品规格型号(SKU)',
    field: 'sku'
  }, {
    name: '规格参数',
    field: 'params'
  }, {
    name: '结构bom',
    field: 'jgbom'
  }, {
    name: '结构bom',
    field: 'bzbom'
  }, {
    name: '产品材质',
    field: 'material'
  }, {
    name: '协议',
    field: 'protocol'
  }, {
    name: '速率',
    field: 'rate'
  }, {
    name: '包装',
    field: 'package'
  }, {
    name: '安规',
    field: 'safe'
  }, {
    name: '接口(输入)',
    field: 'interface'
  }, {
    name: '尺码/数量/长度',
    field: 'other'
  }, {
    name: '产品颜色',
    field: 'color'
  }, {
    name: '功能/版本',
    field: 'version'
  }, {
    name: '输出接口',
    field: 'output'
  }, {
    name: '69码',
    field: 'code69'
  }, {
    name: '备料数量',
    field: 'material_num'
  }, {
    name: '首批订单数量',
    field: 'order_num'
  }, {
    name: '模具费(塑胶)',
    field: 'mould_fare_sj'
  }, {
    name: '模具费(五金)',
    field: 'mould_fare_wj'
  }, {
    name: '电子',
    field: 'electron_fare'
  }, {
    name: '结构/本体',
    field: 'structure_fare'
  }, {
    name: '电源',
    field: 'power_fare'
  }, {
    name: '线材',
    field: 'line_fare'
  }, {
    name: '包材',
    field: 'package_fare'
  }, {
    name: '辅料/配件',
    field: 'parts_fare'
  }, {
    name: '硬盘/运费/其他/DDR',
    field: 'other_fare'
  }, {
    name: '加工费用',
    field: 'process_fare'
  }, {
    name: '认证/测试费用',
    field: 'auth_test_fare'
  }, {
    name: '总成本(未摊模具)',
    field: 'total_cost'
  }, {
    name: '出厂价(TCO成本)',
    field: 'mould_cost'
  }, {
    name: '物料成本价',
    field: 'tco_cost'
  }, {
    name: 'TC0毛利率',
    field: 'tco_rate'
  }, {
    name: '代理商价',
    field: 'agent_price'
  }, {
    name: '渠道毛利润率',
    field: 'channel_rate'
  }, {
    name: '经销价',
    field: 'distribution_price'
  }, {
    name: '经销商毛利率',
    field: 'distribution_rate'
  }, {
    name: '建议零售价',
    field: 'retail_price'
  }, {
    name: '最低零售价',
    field: 'min_retail_price'
  }, {
    name: 'B2C毛利润率',
    field: 'b2c_rate'
  }
]
// 没有权限不可以看
export const ggdykeytable1 = [{
    name: '勾选',
    field: 'indxs'
  }, {
    name: '序号',
    field: 'seq'
  }, {
    name: '品牌',
    field: 'brand'
  },
  {
    name: '产品名称',
    field: 'name'
  }, {
    name: '产品图片',
    field: 'image'
  }, {
    name: '产品SPU',
    field: 'spu'
  }, {
    name: '产品规格型号(SKU)',
    field: 'sku'
  }, {
    name: '规格参数',
    field: 'params'
  }, {
    name: '结构bom',
    field: 'jgbom'
  }, {
    name: '结构bom',
    field: 'bzbom'
  }, {
    name: '产品材质',
    field: 'material'
  }, {
    name: '协议',
    field: 'protocol'
  }, {
    name: '速率',
    field: 'rate'
  }, {
    name: '包装',
    field: 'package'
  }, {
    name: '安规',
    field: 'safe'
  }, {
    name: '接口(输入)',
    field: 'interface'
  }, {
    name: '尺码/数量/长度',
    field: 'other'
  }, {
    name: '产品颜色',
    field: 'color'
  }, {
    name: '功能/版本',
    field: 'version'
  }, {
    name: '输出接口',
    field: 'output'
  }, {
    name: '69码',
    field: 'code69'
  }, {
    name: '备料数量',
    field: 'material_num'
  }, {
    name: '首批订单数量',
    field: 'order_num'
  }, {
    name: '出厂价(TCO成本)',
    field: 'mould_cost'
  }, {
    name: '代理商价',
    field: 'agent_price'
  }, {
    name: '渠道毛利润率',
    field: 'channel_rate'
  }, {
    name: '经销价',
    field: 'distribution_price'
  }, {
    name: '经销商毛利率',
    field: 'distribution_rate'
  }, {
    name: '建议零售价',
    field: 'retail_price'
  }, {
    name: '最低零售价',
    field: 'min_retail_price'
  }, {
    name: 'B2C毛利润率',
    field: 'b2c_rate'
  }
]
// 基础信息-项目编辑新增用
export const infoForm = {
  name: '', //项目名称
  leader_user_id: '', // 项目负责人
  status: '', //项目状态
  level: 1, // 项目优先级
  code: '', // 项目代码
  image: '', // 项目图片
  bh: '', // 项目编号
  cate_id: '', // 产品分类
  plan_start_time: '', // 项目预计开始日期
  plan_end_time: '', // 项目预计结束日期
  start_time: '', // 项目开始日期
  end_time: '', // 项目结束日期
  product_time: '', // 项目量产日期
  online_time: '', // 项目上架日期
  brand_ids: [], // 项目包含品牌
  type: 1 // 项目类型
}
// 基础信息-任务通用
export const taskForm = {
  sn: '', //项目名称
  project_sn: '',
  name: '', // 项目负责人
  status: '', //项目状态
  leader_user_id: '', // 项目优先级
  reviewer_user_id: '', // 项目代码
  task_status_text: '', // 项目图片
  examine_status: '', // 项目编号
  examine_status_text: '',
  project_id: '', // 产品分类
  project_sn: '',
  project_name: '', // 项目预计开始日期
  plan_start_time: '',
  plan_start_time_text: '', // 项目预计结束日期
  plan_end_time_text: '', // 项目开始日期
  plan_end_time: '',
  required_time_text: '', // 要求完成时间
  end_time_text: '', // 项目结束日期
}
// 物料详情——物料报价表-表头
export const wlbjblisthead = [{
    type: 'text',
    field: 'bom_code',
    title: '物料编码',
    width: '300',
    align: 'center',
  },
  {
    type: 'text',
    field: 'bom_name',
    title: '物料名称',
    width: '300',
    align: 'center',
  },
  {
    type: 'text',
    field: 'spec',
    title: '物料规格号',
    width: '',
    align: 'center',
  },
  {
    type: 'text',
    field: 'price',
    title: '单价(￥)',
    width: '300',
    align: 'center',
  },
]
// 物料详情——物料报价表-初始表格默认数据
export const wlbjbdefaultRow = [{
  bom_name: '',
  bom_code: '',
  spec: '',
  price: ''
}, ]
// 物料详情——物料报价表-初始表格默认数据
export const wlbjb_ggdyb_bts = [{
    name: '需要显示列',
    type: 'popup',
    style_self: 'btn'
  },
  {
    name: '导入SKU',
    type: 'other',
    style_self: 'btn'
  },
  {
    name: '导出SKU',
    type: 'other',
    style_self: 'btn'
  },
  {
    name: '导入结构BOM表',
    type: 'other',
    style_self: 'btn'
  },
  {
    name: '导出结构BOM表',
    type: 'other',
    style_self: 'btn'
  },
]
// 任务列表的基础信息
export const rwBaseInfos = [{
    label: '任务编码',
    type: 'ipt_disable',
    value: 'SCFX001',
    field: 'sn'
  },
  {
    label: '任务名称',
    type: 'ipt_disable',
    value: 'SCFX001',
    field: 'name'
  },
  {
    label: '任务负责人',
    type: 'sel',
    value: null,
    field: 'leader_user_id',
    list: [],
  },
  {
    label: '任务审核人',
    type: 'sel',
    value: null,
    field: 'reviewer_user_id',
    list: [],
  },
  {
    label: '业务状态',
    type: 'ipt_disable',
    value: 'SCFX001',
    field: 'task_status',
  },
  {
    label: '任务审核状态',
    type: 'ipt_disable',
    value: 'SCFX001',
    field: 'examine_status',
  },
  {
    label: '所属项目编号',
    type: 'ipt_disable',
    value: 'SCFX001',
    field: 'project_id',
  },
  {
    label: '所属项目名称',
    type: 'ipt_disable',
    value: 'SCFX001',
    field: 'project_name',
  },
  {
    label: '预计开始',
    type: 'date',
    value: [],
    field: 'plan_start_time_text'
  },
  {
    label: '预计完成',
    type: 'date',
    value: [],
    field: 'plan_end_time_text'
  },
  {
    label: '完成日期',
    type: 'date_disable',
    value: [],
    field: 'end_time_text',
  },
]
//项目列表的搜索条件，为了方便重置
export const projectMangeSearch_data = {
  name: '', //项目名称
  leader_user_name: '', //项目负责人
  status: 0, //项目状态:0=全部,10=已保存,20=暂停,30=进行中,40=结束
  task_id: '', //当前任务
  plan_start_time: '', //项目预计开始日期
  plan_end_time: '', //项目预计结束日期
  level: '', //项目优先级:1=正常,2=优先
  start_time: '', //开始时间
  end_time: '', //结束时间
  online_time: '', //上架时间
  product_time: '', //量产时间
  my: 1, //我的待办 1是 0否
  total: 0,
  size: 50,
  page: 1,
}
//项目日志列表的搜索条件，为了方便重置
export const projectLogSearch_data = {
  keywords: '', //项目名称或者项目编号
  user_name: '', //变更人
  type: '', //变更类型:10=项目新增
  module: '', //变更对象: 项目信息 
  start_time: '',
  end_time: '',
  thetime: [],
  total: 0,
  size: 50,
  page: 1,
}
//项目列表的搜索条件，为了方便重置
export const taskMangeSearch_data = {
  sn: '', //项目名称
  name: '', //项目负责人
  leader_user_name: '', //状态
  task_status: '-1', //业务状态:-1=全部，0=排期等待,10=进行中,20=暂停,30=已结束
  examine_status: '-1', //审核状态:-1=全部,0=未提交,10=未审核,20=未下推,30=已结束
  project_name: '', //项目预计开始日期
  end_time: '', //项目预计结束日期
  plan_start_time: '', //项目优先级:1=正常,2=优先
  my: 1, //我的待办 1是 0否
  size: 50,
  page: 1,
}
// 项目新增/编辑_任务信息列表_初始数据（不给表格渲染错误_
export const tasklist = [{
  index: 1,
  project_id: '',
  name: '',
  image: '',
  spu: '',
  sku: '',
  links_qd_bom: '',
  links_bz_bom: '',
  material: '',
  protocol: '',
  rate: '',
  package: '',
  safe: '',
  interface: '',
  other: '',
  color: '',
  version: '',
  output: '',
  material_num: '',
  order_num: '',
  mould_fare_sj: '',
  mould_fare_wj: '',
  electron_fare: '',
  structure_fare: '',
  line_fare: '',
  package_fare: '',
  parts_fare: '',
  process_fare: '',
  auth_test_fare: '',
  total_cost: '',
  mould_cost: '',
  tco_cost: '',
  tco_rate: '',
  agent_price: '',
  channel_rate: '',
  distribution_price: '',
  test: '',
  retail_price: '',
  min_retail_price: '',
  b2c_rate: '',
}, ]
// 项目新增/编辑_规格定义表_初始数据（不给表格渲染错误_
export const skulist = [{
  id: 1,
  index: 0,
  project_id: 8, //项目id
  name: 'M.2双协议硬盘盒', // 产品名称
  image: '', //产品图片
  spu: '', //产品SPU
  links_qd_bom: '', // 结构BOM清单
  links_bz_bom: '', // 包装BOM清单
  material: '', // 包装BOM清单
  protocol: '', //协议
  rate: '', //速率
  package: '', //包装
  safe: '', //安规
  interface: '', //接口(输入)
  other: '', //尺码/数量/长度
  color: '', //产品颜色
  version: '', //功能/版本
  output: '', //输出接口
  material_num: '', //备料数量
  order_num: '', //首批订单数量
  mould_fare_sj: '', //模具费(塑胶)
  mould_fare_wj: '', //模具费(五金)
  electron_fare: '', //电子
  structure_fare: '', // 结构
  line_fare: '', //线材
  package_fare: '', //包材
  parts_fare: '', //配件
  process_fare: '', //加工费用
  auth_test_fare: '', //'认证/测试费用
  total_cost: '', //总成本(未摊模具)
  mould_cost: '', //含摊模具成本(工厂出厂成本)
  tco_cost: '', //TCO成本
  tco_rate: '', //TCO毛利润率
  agent_price: '', //代理商价
  channel_rate: '', //渠道毛利润率
  distribution_price: '', //经销价
  distribution_price: '', // 经销商毛利率 (没有)
  retail_price: '', //建议零售价
  min_retail_price: '', //最低零售价
  b2c_rate: '', //B2C毛利润率
}, ]
// 项目新增/编辑_任务信息列表_初始数据（不给表格渲染错误_
export const prlisttopBt = [{
    name: '保存',
    type: 'defalut',
    methodName: 'saveProject'
  },
  {
    name: '继续项目',
    type: 'defalut',
    methodName: 'goOnPrijectbt'
  },
  {
    name: '暂停',
    type: 'defalut',
    methodName: 'stopProjectbt'
  },
  {
    name: '结束',
    type: 'defalut',
    methodName: 'closeProjectbt'
  },
  {
    name: '项目资料',
    type: 'defalut',
    methodName: 'projectInfobt'
  },
  {
    name: '下推',
    type: 'defalut',
    methodName: 'pushdown'
  },
  {
    name: '日志',
    type: 'defalut',
    methodName: 'logbt'
  },
]
export const addprlisttopBt = [{
    name: '保存',
    type: 'defalut',
    methodName: 'saveProject'
  },
  // {
  //   name: '项目资料',
  //   type: 'defalut',
  //   methodName: 'projectInfobt'
  // },
  // {
  //   name: '下推',
  //   type: 'defalut',
  //   methodName: 'pushdown'
  // },
]
// 项目新增/编辑_任务信息列表_表头
export const pr_listHeader = [{
    type: 'checkbox',
    align: 'center',
    width: '36'
  },
  {
    type: 'img',
    field: 'image',
    title: '项目图片',
    width: '133',
    align: 'center',
  },
  {
    type: 'router',
    field: 'name',
    title: '项目名称',
    width: '133',
    align: 'center',
  },
  {
    type: 'text',
    field: 'leader_user_name',
    title: '项目负责人',
    width: '133',
    align: 'center',
  },
  {
    type: 'text',
    field: 'task_text',
    title: '当前任务及状态',
    width: '150',
    align: 'center',
  },
  {
    type: 'text',
    field: 'next_task',
    title: '即将进行',
    width: '170',
    align: 'center',
  },
  {
    type: 'text',
    field: 'status_text',
    title: '项目状态',
    width: '133',
    align: 'center',
  },
  {
    type: 'text_color_row',
    field: 'level_text',
    title: '项目优先级',
    width: '133',
    align: 'center',
  },
  {
    type: 'text',
    field: 'plan_start_time',
    title: '项目预计开始日期',
    width: '133',
    align: 'center',
  },
  {
    type: 'text',
    field: 'plan_end_time',
    title: '项目预计结束日期',
    width: '133',
    align: 'center',
  },
  {
    type: 'text',
    field: 'end_time',
    title: '项目开始日期',
    width: '110',
    align: 'center',
  },
  {
    type: 'text',
    field: 'product_time',
    title: '项目量产日期',
    width: '110',
    align: 'center',
  },
  {
    type: 'text',
    field: 'online_time',
    title: '项目上架日期',
    width: '110',
    align: 'center',
  },
  {
    type: 'text',
    field: 'end_time',
    title: '项目结束日期',
    width: '133',
    align: 'center',
  },
  {
    type: 'pushDown',
    field: 'pushDown',
    title: '操作',
    width: '120',
    align: 'center',
  },
]
// 项目新增/编辑_任务信息列表_表头
export const pr_defaultRow = [{
  id: 0,
  sn: '',
  code: '',
  image: '',
  name: '',
  leader_user_name: '',
  task_text: '',
  next_task: '',
  status_text: '',
  level: '',
  plan_start_time: '',
  plan_end_time: '',
  end_time: '',
  product_time: '',
  online_time: '',
  end_time: '',
  pushDown: ''
}, ]
// 项目新增/编辑_任务信息列表_表头
export const rw_listHeader = [{
    type: 'text',
    field: 'name',
    title: '任务名称',
    width: '200',
    align: 'left',
  },
  {
    type: 'text',
    field: 'leader_user_name',
    title: '任务负责人',
    width: '145',
    align: 'left',
  },
  {
    type: 'editable_sel',
    field: 'reviewer_user_id',
    title: '任务审核人',
    width: '145',
    align: 'center',
    beforeStr: 'mt',
  },
  {
    type: 'text',
    field: 'committed_step_text',
    title: '是否关键步骤',
    width: '145',
    align: 'left',
  }, {
    type: 'text',
    field: 'task_status_text',
    title: '任务审核状态',
    width: '145',
    align: 'left',
  },
  {
    type: 'text',
    field: 'plan_start_time_text',
    title: '预计开始时间',
    width: '145',
    align: 'left',
  },
  {
    type: 'text',
    field: 'plan_end_time_text',
    title: '预计结束时间',
    width: '145',
    align: 'left',
  },
  {
    type: 'text',
    field: 'start_time_text',
    title: '开始时间',
    width: '145',
    align: 'left',
  },
  {
    type: 'text',
    field: 'end_time_text',
    title: '结束时间',
    width: '145',
    align: 'left',
  },
  {
    type: 'text',
    field: 'msg',
    title: '驳回原因 ',
    width: '',
    align: 'left',
  },
]
// 项目新增/编辑_规格定义_表头
export const ggdy_listHeader = [{
    type: 'checkbox',
    align: 'center',
    width: '50'
  },
  {
    type: 'index',
    field: 'index',
    title: '序号',
    width: '50',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'name',
    title: '产品名称',
    width: '200',
    align: 'center',
  },
  {
    type: 'img_upload',
    field: 'image',
    title: '产品图片',
    width: '100',
    align: 'center',
    upload_url: baseUrl + 'project/upload/file',
  },
  {
    type: 'editable_ipt',
    field: 'spu',
    title: '产品SPU',
    width: '200',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'sku',
    title: '产品规格型号(SKU)',
    width: '200',
    align: 'center',
  },
  {
    type: 'router',
    field: 'links_qd_bom_text',
    title: '结构BOM清单',
    width: '120',
    align: 'center',
  },
  {
    type: 'router',
    field: 'links_bz_bom_text',
    title: '包装BOM清单',
    width: '120',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'material',
    title: '产品材质',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'protocol',
    title: '协议',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'rate',
    title: '速率',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_sel',
    field: 'package',
    title: '包装',
    width: '100',
    align: 'center',
    beforeStr: 'bz',
  },
  {
    type: 'editable_sel',
    field: 'safe',
    title: '安规',
    width: '100',
    align: 'center',
    beforeStr: 'ag',
  },
  {
    type: 'editable_ipt',
    field: 'interface',
    title: '接口(输入)',
    width: '140',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'other',
    title: '尺码/数量/长度',
    width: '160',
    align: 'center',
  },
  {
    type: 'editable_sel',
    field: 'color',
    title: '产品颜色',
    width: '100',
    align: 'center',
    beforeStr: 'ys',
  },
  {
    type: 'editable_ipt',
    field: 'version',
    title: '功能/版本',
    width: '120',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'output',
    title: '输出接口',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_integer',
    field: 'material_num',
    title: '备料数量',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_integer',
    field: 'order_num',
    title: '首批订单数量',
    width: '140',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'mould_fare_sj',
    title: '模具费(塑胶)',
    width: '140',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'mould_fare_wj',
    title: '模具费(五金)',
    width: '140',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'electron_fare',
    title: '电子',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'structure_fare',
    title: '结构',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'line_fare',
    title: '线材',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'package_fare',
    title: '包材',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'parts_fare',
    title: '配件',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'process_fare',
    title: '加工费用',
    width: '100',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'auth_test_fare',
    title: '认证/测试费用',
    width: '140',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'total_cost',
    title: '总成本(未摊模具)',
    width: '160',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'mould_cost',
    title: '出厂价(TCO成本)',
    width: '240',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'tco_cost',
    title: '物料成本价',
    width: '100',
    align: 'center',
  },
  {
    type: 'text_count',
    field: 'tco_rate',
    title: 'TCO毛利润率',
    width: '120',
    align: 'center',
    count: 'tco_cost|-|mould_cost|/|tco_cost',
  },
  {
    type: 'editable_ipt_float',
    field: 'agent_price',
    title: '代理商价',
    width: '100',
    align: 'center',
  },
  {
    type: 'text_count',
    field: 'channel_rate',
    title: '渠道毛利润率',
    width: '120',
    align: 'center',
    count: 'agent_price|-|tco_cost|/|agent_price',
  },
  {
    type: 'editable_ipt_float',
    field: 'distribution_price',
    title: '经销价',
    width: '100',
    align: 'center',
  },
  {
    type: 'text_count',
    field: 'distribution_rate',
    title: '经销商毛利率',
    width: '120',
    align: 'center',
    count: 'min_retail_price|-|distribution_price|/|min_retail_price',
  },
  {
    type: 'editable_ipt_float',
    field: 'retail_price',
    title: '建议零售价',
    width: '120',
    align: 'center',
  },
  {
    type: 'editable_ipt_float',
    field: 'min_retail_price',
    title: '最低零售价',
    width: '120',
    align: 'center',
  },
  {
    type: 'text_count',
    field: 'b2c_rate',
    title: 'B2C毛利润率',
    width: '120',
    align: 'center',
    count: 'min_retail_price|-|tco_cost|/|min_retail_price',
  },
]
// 产品资料-表格头部(公共)
export const cpPPT_listHeader = [{
    type: 'text',
    field: 'title',
    title: '文件名称',
    width: '412',
    align: 'center',
  },
  {
    type: 'text',
    field: 'create_time',
    title: '上传时间',
    width: '412',
    align: 'center',
  },
  {
    type: 'operation',
    field: 'operation',
    title: '操作',
    width: '412',
    align: 'center',
  },
  {
    type: 'editable_ipt',
    field: 'remark',
    title: '备注',
    width: '',
    align: 'center',
  },
]
// 产品资料 表格 - 规格定价 - 默认值
export const cpPPT_defaultVal = []
// 产品资料 表格 - 规格定价 - 表头按钮
export const cpppt_headerBtns = [
  // {name:'下载模板',type:'download',style_self:'btn'},
  // {name:'上传文件',type:'upload',style_self:'btn'},
  // {name:'填写共享盘链接',type:'write_links',style_self:'btn'}
  {
    name: '下载模板',
    type: 'download',
    style_self: 'btn'
  },
  {
    name: '文件上传',
    type: 'upload_file',
    style_self: 'btn_upload',
    upload_url: baseUrl + 'project/upload/file',
  },
  {
    name: '填写共享盘链接',
    type: 'write_links',
    style_self: 'btn'
  },
]

// 包装设计表头
export const bzsjdata_listHeader = [{
    type: 'checkbox',
    align: 'center',
    width: '50'
  },
  {
    title: '盒型选择',
    type: 'text',
    field: 'name',
    width: '128',
    align: 'left',
  },
  {
    title: '产品图片',
    type: 'img',
    field: 'image',
    width: '128',
    align: 'center',
  },
  {
    title: '包装形式',
    type: 'text',
    field: 'type',
    width: '128',
    align: 'left',
  },
  {
    title: '包装结构组成',
    type: 'text',
    field: 'structure',
    width: '280',
    align: 'left',
  },
  {
    title: '包装尺寸（不含挂钩尺寸）',
    type: 'text',
    field: 'size',
    width: '280',
    align: 'left',
  },
  {
    title: '运输外箱尺寸',
    type: 'text',
    field: 'transport_size',
    width: '220',
    align: 'left',
  },
  {
    title: '用量 (分子)',
    type: 'text',
    field: 'molecule',
    width: '75',
    align: 'center',
  },
  {
    title: '用量 (分母)',
    type: 'text',
    field: 'denominator',
    width: '75',
    align: 'left',
  },
  {
    title: '单价 (¥)',
    type: 'text',
    field: 'price',
    width: '70',
    align: 'left',
  },
  {
    title: '备注',
    type: 'text',
    field: 'remark',
    width: '',
    align: 'left'
  },
]
// 包装设计表头默认数据
export const bzsjdata_defaultVal = [{
  name: '',
  image: '',
  type: '',
  structure: '',
  size: '',
  transport_size: '',
  molecule: '',
  denominator: '',
  price: '',
  remark: '',
}, ]